import { useRef } from 'react';
import appLogo from '../../..//assets/app-logo.svg';

const ACTIVATION_CLICKS = 5;
const ACTIVATION_WINDOW_MS = 5_000;
const AUTO_FOLLOW_FEATURE_ENABLED = import.meta.env.VITE_ENABLE_AUTO_FOLLOW_FEATURE === 'true';

interface AppLogoProps {
  onActivated: () => void;
}

function AppLogo({ onActivated }: AppLogoProps) {
  const clickTimestampsRef = useRef<number[]>([]);

  const onAppLogoClicked = () => {
    if (!AUTO_FOLLOW_FEATURE_ENABLED) {
      return;
    }

    const now = Date.now();
    const windowStart = now - ACTIVATION_WINDOW_MS;

    clickTimestampsRef.current = clickTimestampsRef.current.filter((timestamp) => timestamp >= windowStart);
    clickTimestampsRef.current.push(now);

    if (clickTimestampsRef.current.length >= ACTIVATION_CLICKS) {
      clickTimestampsRef.current = [];
      onActivated();
    }
  };

  return (
    <img
      src={appLogo}
      alt='Remote Operations Center'
      onClick={onAppLogoClicked}
      style={{
        height: '20px',
        width: 'auto',
        cursor: 'default'
      }}
    />
  );
}

export default AppLogo;
